export default __webpack_public_path__ + "64d81cd80339204f079974e715c849f3.svg";